import {
  Environment,
  Network,
  RecordSource,
  Store,
  QueryResponseCache,
  VIEWER_TYPE,
  VIEWER_ID,
  Variables,
  CacheConfig,
  GraphQLResponse,
} from 'relay-runtime';
import { graphql, getRelayCacheSize } from '../config/constants';
import { authHeaders } from '../services/authentication';

// TIME FOR WHICH WE WANT TO STORE THE VALUE
const oneMinute = 60 * 1000;

// INITIALIZING QueryResponseCache WITH SIZE and TIME
const cache = new QueryResponseCache({
  size: getRelayCacheSize(),
  ttl: oneMinute,
});

const HTTP_ENDPOINT = `${graphql[env].url}/graphql`;

async function fetchQuery(
  operation: any,
  variables: Variables,
  cacheConfig: CacheConfig,
): Promise<GraphQLResponse> {
  const forceFetch = cacheConfig && cacheConfig.force;
  const queryID = operation.text;
  const isQuery = operation.operationKind === 'query';
  const body = JSON.stringify({
    query: operation.text,
    variables,
    operationName: operation.name,
  });

  if (isQuery && !forceFetch) {
    if (cache.get(queryID, variables) !== null) {
      return cache.get(queryID, variables);
    }
  }

  try {
    const resp = await fetch(HTTP_ENDPOINT, {
      method: 'POST',
      headers: authHeaders(),
      body,
    });
    const json = await resp.json();
    // Solve problem when fetchQuery do not return error, when data is set
    // See https://github.com/facebook/relay/issues/1913
    if (json && json.errors) {
      return { data: null, errors: json.errors };
    }

    // UPDATE CACHE ON QUERIES
    if (isQuery && json) {
      cache.set(queryID, variables, json);
    }
    return json;
  } catch (error: any) {
    console.error('fetchQuery error', error);
    if (error.message === 'Network request failed') {
      if (isQuery) {
        const data = cache.get(queryID, variables);
        if (data) {
          return data;
        }
      }
    }
    throw error;
  }
}

function createRelayEnvironment() {
  return new Environment({
    getDataID: (_, typeName) => (typeName === VIEWER_TYPE ? VIEWER_ID : undefined),
    network: Network.create(fetchQuery),
    store: new Store(new RecordSource()),
  });
}

export const RelayEnvironment = createRelayEnvironment();
